/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'user-connected-request-popup',
  components: {},
  props: ['memberUserInfo'],
  data () {
    return {
      message:'',
      chatRequestDetails:null,
      selfUserDetails:null
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getUserDetailsAgainFun() {
      this.selfUserDetails = this.$store.getters.selfUserInfoGetters.data
      return
    },
  },
  mounted () {
    this.chatRequestDetails = this.memberUserInfo
    this.getUserDetailsAgainFun
  },
  methods: {
    sendChatRequestConfirm(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              from_user:this.selfUserDetails.id,
              to_user:this.chatRequestDetails.id,
              message:this.message,
            }
            this.$store.dispatch('SendChatConnectionRequestFun', data)
              .then((res) => {
                  toast.success(res.data.user_msg || res.data.msg);
                  bus.$emit('sendRequestMessage', {
                    from_user: this.selfUserDetails.id,
                    second_user_id:this.chatRequestDetails.id,
                    to_user: this.chatRequestDetails.id
                  });
                  this.closeChatRequestConfirm()
              }).catch((error) => {
                  toast.error(error.data.user_msg || error.data.msg);
                  this.closeChatRequestConfirm()
              })
            return;
        }
      });
    },
    closeChatRequestConfirm(){
      bus.$emit('userConnectedRequestStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
  },
  watch:{
    getUserDetailsAgainFun() {
      return this.$store.getters.selfUserInfoGetters
    },
  }
}